import React from "react";

// Простий iOS-style / Material-style сегментний перемикач
function WomSegmented({ value, onChange, options, style = {}, full = false }) {
  return (
    <div
      style={{
        display: "inline-flex",
        borderRadius: 999,
        padding: 4,
        gap: 4,
        background: "rgba(15,23,42,0.9)",
        border: "1px solid rgba(148,163,184,0.6)",
        width: full ? "100%" : "auto",
        ...style,
      }}
    >
      {options.map((opt) => {
        const active = opt.value === value;
        return (
          <button
            key={opt.value}
            type="button"
            onClick={() => onChange(opt.value)}
            style={{
              flex: full ? 1 : undefined,
              padding: "6px 12px",
              borderRadius: 999,
              border: "none",
              cursor: "pointer",
              background: active
                ? "rgba(56,189,248,0.35)"
                : "transparent",
              color: "#e5e7eb",
              fontSize: 12,
              fontWeight: active ? 600 : 500,
              whiteSpace: "nowrap",
              transition: "0.2s",
            }}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}

export default WomSegmented;
export { WomSegmented };
